import script from "./TheTable.vue?vue&type=script&setup=true&lang=js"
export * from "./TheTable.vue?vue&type=script&setup=true&lang=js"

import "./TheTable.vue?vue&type=style&index=0&id=7a1c53d5&scoped=true&lang=css"

import exportComponent from "F:\\.openserver\\OpenServer\\domains\\geo_exams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a1c53d5"]])

export default __exports__